(function () {
  'use strict';

  var PROMO_URL = '/pages/promociones-excepcionales';
  var DEADLINE = Date.parse('2026-09-20T04:59:59Z');

  function normalize(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('es');
  }

  function updatePromotionLinks(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('.header__primary-nav a, #menu-drawer a');
    var expired = Date.now() > DEADLINE;

    links.forEach(function (link) {
      var label = normalize(link.textContent);
      var isBlogLink = label === 'blog';
      var isPromotionLink = link.classList.contains('cp-promo-nav') || link.getAttribute('href') === PROMO_URL;

      if (!isBlogLink && !isPromotionLink) return;

      if (expired) {
        var item = link.closest('li');
        (item || link).hidden = true;
        return;
      }

      link.textContent = 'PROMOS';
      link.setAttribute('href', PROMO_URL);
      link.classList.add('cp-promo-nav');
      link.setAttribute('aria-label', 'Ver las promociones excepcionales');

      var promoItem = link.closest('li');
      var menuList = promoItem && promoItem.parentElement;

      if (menuList) {
        var targetItem = Array.prototype.slice.call(menuList.children).find(function (item) {
          var targetLink = item.querySelector('a, button');
          return targetLink && normalize(targetLink.textContent) === 'puntos de venta';
        });

        if (targetItem && targetItem !== promoItem) {
          menuList.insertBefore(promoItem, targetItem);
        }
      }
    });
  }

  function twoDigits(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function updateCountdown(section) {
    var countdown = section.querySelector('[data-promo-countdown]');
    if (!countdown) return false;

    var deadline = Date.parse(section.getAttribute('data-promo-deadline')) || DEADLINE;
    var remaining = deadline - Date.now();

    if (remaining <= 0) {
      var active = section.querySelector('[data-promo-active]');
      var expired = section.querySelector('[data-promo-expired]');
      if (active) active.hidden = true;
      if (expired) expired.hidden = false;
      updatePromotionLinks(document);
      return false;
    }

    var days = Math.floor(remaining / 86400000);
    var hours = Math.floor((remaining % 86400000) / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    var seconds = Math.floor((remaining % 60000) / 1000);

    countdown.querySelector('[data-promo-days]').textContent = twoDigits(days);
    countdown.querySelector('[data-promo-hours]').textContent = twoDigits(hours);
    countdown.querySelector('[data-promo-minutes]').textContent = twoDigits(minutes);
    countdown.querySelector('[data-promo-seconds]').textContent = twoDigits(seconds);
    return true;
  }

  function initPromotionPage(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-promo-section]');

    sections.forEach(function (section) {
      if (section.dataset.promoInitialized === 'true') return;
      section.dataset.promoInitialized = 'true';

      if (!updateCountdown(section)) return;
      window.setInterval(function () { updateCountdown(section); }, 1000);
    });
  }

  function initQuantityControls(root) {
    var scope = root || document;
    var controls = scope.querySelectorAll('[data-promo-quantity]');

    controls.forEach(function (control) {
      if (control.dataset.promoQuantityInitialized === 'true') return;
      control.dataset.promoQuantityInitialized = 'true';

      var input = control.querySelector('input[type="number"]');
      var minus = control.querySelector('[data-promo-qty-minus]');
      var plus = control.querySelector('[data-promo-qty-plus]');
      if (!input || !minus || !plus) return;

      function clamp(value) {
        var minimum = parseInt(input.min, 10) || 1;
        var maximum = parseInt(input.max, 10) || 99;
        return Math.min(maximum, Math.max(minimum, parseInt(value, 10) || minimum));
      }

      function setQuantity(value) {
        input.value = clamp(value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      minus.addEventListener('click', function () { setQuantity(parseInt(input.value, 10) - 1); });
      plus.addEventListener('click', function () { setQuantity(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { input.value = clamp(input.value); });
    });
  }

  function initPromoGalleries(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll('[data-promo-gallery]');

    galleries.forEach(function (gallery) {
      if (gallery.dataset.promoGalleryInitialized === 'true') return;
      gallery.dataset.promoGalleryInitialized = 'true';

      var track = gallery.querySelector('[data-promo-gallery-track]');
      var slides = gallery.querySelectorAll('[data-promo-gallery-slide]');
      var previous = gallery.querySelector('[data-promo-gallery-prev]');
      var next = gallery.querySelector('[data-promo-gallery-next]');
      var dots = gallery.querySelectorAll('[data-promo-gallery-dot]');
      if (!track || slides.length < 2) return;

      var currentIndex = 0;
      var touchStartX = null;

      function renderDots() {
        dots.forEach(function (dot, index) {
          dot.setAttribute('aria-current', index === currentIndex ? 'true' : 'false');
        });
      }

      function goTo(index) {
        currentIndex = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.hidden = slideIndex !== currentIndex;
          slide.setAttribute('aria-hidden', slideIndex === currentIndex ? 'false' : 'true');
        });
        renderDots();
      }

      previous.addEventListener('click', function () { goTo(currentIndex - 1); });
      next.addEventListener('click', function () { goTo(currentIndex + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.promoGalleryDot, 10) || 0); });
      });

      track.addEventListener('touchstart', function (event) {
        touchStartX = event.touches.length ? event.touches[0].clientX : null;
      }, { passive: true });

      track.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches.length) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 35) return;
        goTo(currentIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });

      goTo(0);
    });
  }

  function init(root) {
    updatePromotionLinks(root || document);
    initPromotionPage(root || document);
    initQuantityControls(root || document);
    initPromoGalleries(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
